export const search = {
  // Search page
  "search.title": "Search Suppliers by Product",
  "search.results": "results found",
  "search.results_title": "Search Results",
  "search.no_results": "No suppliers found",
  "search.no_results_desc": "Try searching for a product name (e.g., iPhone, rice, car) or category",
  "search.filters": "Filters",
  "search.sort": "Sort by",
  "search.sort.relevance": "Relevance",
  "search.sort.distance": "Distance",
  "search.sort.rating": "Rating",
  "search.sort.name": "Name",
  "search.sort.alpha_asc": "Name (A-Z)",
  "search.sort.alpha_desc": "Name (Z-A)",
  "search.placeholder": "Search by product (iPhone, rice...) or category",
  "search.suggestions": "Try searching for:",
  "search.loading": "Loading suppliers...",
  "search.showing": "Showing",
  "search.of": "of",
  "search.suppliers": "suppliers",
  "search.total_suppliers": "{{count}} total suppliers found",
  "search.total_suppliers_count": "{{count}} total suppliers",
  "search.intelligent_hint": "Search any product to find all suppliers in that category",
  
  // Category match indicator
  "search.category_match": "Showing suppliers in category: {{category}}",
  "search.product_match": "Found from product: {{product}}",
  
  // Filters
  "filter.category": "Category",
  "filter.location": "Location",
  "filter.distance": "Distance",
  "filter.rating": "Minimum rating",
  "filter.price_range": "Price range",
  "filter.min": "Min",
  "filter.max": "Max",
  "filter.verified": "Verified businesses only",
  "filter.apply": "Apply filters",
  "filter.clear": "Clear filters",
  "filter.reset": "Reset filters",
  "filter.city": "Main city",
  "filter.all_cities": "All cities",
  "filter.all_categories": "All categories",
  "filter.max_distance": "Maximum distance",
  "filter.min_rating": "Minimum rating",
  "filter.all_ratings": "All ratings",
  "filter.verified_only": "Verified businesses only",
  "filter.by_city": "Filter by city",
  "filter.by_category": "Filter by category",
  "filter.by_distance": "Filter by distance",
  "filter.by_rating": "Filter by rating",
  "filter.stars": "stars",
  
  // Distance options
  "distance.5km": "Within 5 km",
  "distance.10km": "Within 10 km",
  "distance.25km": "Within 25 km",
  "distance.50km": "Within 50 km",
  "distance.100km": "Within 100 km",
  
  // View options
  "view.list": "List view",
  "view.map": "Map view",
  "view.grid": "Grid view",
  
  // Results
  "results.verified": "Verified",
  "results.reviews": "reviews",
  "results.view_profile": "View Profile",
  "results.contact": "Contact",
  "results.no_match": "No suppliers match the selected filters.",
  
  // Search suggestions
  "search.including": "Including",
  "search.suggested_category": "Suggested category",

  // Search translation (Alibaba-style)
  "search.translating": "Translating...",
  "search.translated_from": "Translated from",
  
  // Search suggestion dropdown
  "search.suggestion.recent": "Recent",
  "search.suggestion.supplier": "Supplier",
  "search.suggestion.category": "Category",
  "search.type.suppliers": "Suppliers",
  "search.type.products": "Products",
  "search.type.categories": "Categories",
  "search.type.locations": "Locations",
  "search.results_count": "result{{plural}}",
  "search.try_other_terms": "Try other search terms",
  "search.recent_searches": "Recent searches",
  "search.clear": "Clear",
  "search.keyboard_navigate": "navigate",
  "search.keyboard_select": "select",
  "search.keyboard_close": "close",
  
  // Location and UI
  "search.locating": "Getting location...",
  "search.use_my_location": "Use my location",
  "search.my_location": "My location",
  "search.your_position": "Your position",
  "search.reset": "Reset",
  "search.hide_filters": "Hide filters",
  "search.show_filters": "Show filters",
  "search.verified": "Verified",
  "search.full_address_available": "Full address available",
  "search.call": "Call",
  "search.send_email": "Send email",
  "search.make_appointment": "Make appointment",
  "search.view_details": "View details",
  "search.distance_from": "Distance from your current position",
  "search.distance_from_location": "Distance from {{location}}",
  "search.select_city_or_use_position": "Select a city or use your position",
  "search.location_not_supported": "Geolocation is not supported by your browser",
  "search.location_permission_denied": "You have denied access to your position",
  "search.location_unavailable": "Position unavailable",
  "search.location_timeout": "Location request timed out",
  "search.location_error": "Error getting position",
  "search.timeout_error": "Search took too long. Please try again.",
  "search.map_timeout_error": "Map search took too long.",

  // Home page search placeholders
  "search.product_placeholder": "Search for a product...",
  "search.supplier_placeholder": "Supplier name",
  "search.location_placeholder": "Location",
  "search.category_placeholder": "Category",
  "search.find_products": "Search",
  "search.find_suppliers": "Search"
};

export default search;